import FAQSectionI18n from "@/components/landing/shared/FAQSectionI18n";
const FAQMarketingSection = () => <FAQSectionI18n translationPrefix="marketingSolution" />;
export default FAQMarketingSection;
